import axios from 'axios'
export const LOAD_FUND_PROFILE = 'load_fundProfile'
export const LOAD_RELATED_FUNDS = 'load_related_funds'
export const REMOVE_RELATED_FUND = 'remove_related_funds'
export const LOAD_PERFORMANCE = 'load_performance'
export const SET_INDEX = 'set_index'
export const SET_PROFILE_CATEGORY = 'setProfileCategory'
export const SET_SAMPLE_PARAM = 'set_sample_param'
export const SET_SELECTED_FUND_TICKERS = 'set_selected_fund_tickers'
export const SET_TA_FUND_TICKERS = 'set_ta_fund_tickers'
export const RESET_PAGE = 'reset_page'
export const SET_SELECTED_CHARS = 'set_selected_chars'
export const SET_SELECTED_SECTOR = 'set_selected_sector'
export const SET_SELECTED_COUNTRY = 'set_selected_country'
export const RESET_SCROLL_COUNTRY = 'reset_scroll_country'
export const SET_ACTIVE_PANE = 'set_active_pane'
export const REMOVE_TICKER = 'remove_ticker'
export const CLEAR_TICKERS = 'clear_tickers'
export const CLEAR_INITIAL_TICKERS = 'clear_initial_tickers'
export const LOADING = 'loading'

export const FETCH_STRUCTURE_LOADING = 'fetchStructureLoading'
export const FETCH_STRUCTURE_ERROR = 'fetchStructureError'
export const SET_FUND_DETAILS_STRUCTURE = 'setFundDetails'

export const SET_FUND_DETAILS_PERFORMANCE = 'setFundDetailsPerformance'

export const SET_FUND_DETAILS_RUN_ID = 'setFundDetailsRunID'

export const ADD_PENDING_DATASPAN_REQUESTS = 'addPendingDataspanRequests'
export const REMOVE_PENDING_DATASPAN_REQUESTS = 'removePendingDataspanRequests'

export const PERF_LOADING = 'perfLoading'
export const ERROR = 'error'
export const SELECTED_RELATED = 'selected_related'
export const SET_PERF_START_DATE = 'set_perf_start_date'
export const SET_PERF_END_DATE = 'set_perf_end_date'
export const SET_FULLEXCEL_STATUS = 'set_fullexcelstatus'
export const SET_CURRENTEXCEL_STATUS = 'set_currentexcelstatus'
export const SET_CURRENT_URL = 'set_current_url'
export const SET_GROWTH_METRIC_QUALITY = 'set_growth_metric_quality'
export const SET_ALL_GROWTH_CHARS = 'set_all_growth_chars'
export const SET_SELECT_ADDITIONALPI = 'set_select_additionalpi'
export const SET_SELECTED_RISK = 'set_selected_risk'
export const SET_DRAW_DOWN_PERIOD = 'set_draw_down_period'
export const SET_ACTIVE_SOE_PANE = 'set_active_soe_pane'
export const SET_ACTIVE_SOE_DATA_TYPE = 'set_active_soe_data_type'
export const TOGGLE_SHOW_FUND_SELECTION = 'toggle_show_fund_selection'
export const LOAD_SEARCH_RESULTS = 'load_search_results'
export const LOADING_SEARCH_RESULTS = 'loading_search_results'
export const CLEAR_SEARCH_RESULTS = 'clear_search_results'
export const LOAD_PERSONAL_STRATEGIES = 'get_personal_strategies'
export const DELETE_A_STRATEGY = 'delete_a_stategy'
export const SHOW_A_STRATEGY = 'show_a_stategy'
export const SHOW_ALL_STRATEGIES = 'show_all_stategies'
export const SHOW_STRATEGY_EDITOR = 'show_strategy_editor'
export const CLOSE_STRATEGY_EDITOR = 'close_strategy_editor'
export const UPDATE_STRATEGY = 'update_strategy'
export const LOAD_TYPEAHEAD_SUGGESTIONS = 'load_typeahead_suggestions'
export const SAVING_NEW_STRATEGY_IN_PROGRESS = 'saving_new_strategy_in_progress'
export const SAVING_STRATEGY_IN_PROGRESS = 'saving_strategy_in_progress'
export const SAVING_STRATEGY_COMPLETE = 'saving_strategy_complete'
export const SAVE_NEW_STRATEGY = 'save_new_strategy'
export const LOAD_BENCHMARKS = 'load_benchmarks'
export const ADD_SCREENED_FUND = 'add_screened_fund'
export const REMOVE_SCREENED_FUND = 'remove_screened_fund'
export const SET_SCREENED_FUNDS = 'hard_set_screend_funds'
export const UPDATE_SEARCH_TICKER = 'update_search_ticker'
export const APPEND_SEARCH_TICKER = 'append_search_ticker'
export const REMOVE_SEARCH_TICKER = 'remove_search_ticker'
export const EDIT_TICKERS = 'edit_tickers'
export const UPDATE_FUND_COUNT = 'update_fund_count'

const API_URL = process.env.REACT_APP_API_URL
const FUNDCHAR_URL_STRUCTURE = `${API_URL}/fundchar/data/?`

export const paneOpts = {
  metrics: 'metrics',
  chars: 'chars',
  expos: 'expos',
  perf: 'perf',
  details: 'details',
  factors: 'factors',
  esg: 'esg'
}

export function updateQueryParams() {
  return (dispatch, getState) => {
    const state = getState();

    if (state.fundData.data) {
      const fundsList = state.params.screenedFunds.slice(0, 6);

      // update name field in fundsList with corresponding name from state.fundData.data[i].name
      fundsList.forEach((fund) => {
        let matchingFundData;

        if (fund.type === 'ticker') {
          matchingFundData = state.fundData.data.find(data => data.ticker === fund.ticker);
        } else if (fund.type === 'user_model') {
          const matchingFundData = state.fundData.data.find(data => data.externalID?.toUpperCase() === fund.externalID?.toUpperCase());
          if (matchingFundData?.underlyingPerformances) {
            const tickers = matchingFundData.underlyingPerformances.map(performance => performance.ticker).join(',');
            fund.ticker = tickers;
          }
        }

        if (matchingFundData) {
          fund.name = matchingFundData.name;
        }
      });

      const tab = state.params.activePane;
      const unauthUserEmail = state.params.unauthUserEmail
      const baseUrl = `${window.location.origin}${window.location.pathname}#fund-comparison`;

      const tickersArray = [];

      fundsList.forEach(fund => {
        if (fund.type === 'ticker' || fund.type === 'wt_model') {
          tickersArray.push(fund.ticker);
        }
      });

      const tickersParam = tickersArray.length ? `tickers=${tickersArray.join(',')}` : '';

      const paramsArray = [];
      if (tickersParam) {
        paramsArray.push(tickersParam);
      }

      if (unauthUserEmail) {
        paramsArray.push(`email=${encodeURIComponent(unauthUserEmail)}`);
      }         

      const paramsString = paramsArray.join('&');

      const fullUrl = `${baseUrl}&${paramsString}&tab=${tab}`;

      dispatch({ type: SET_CURRENT_URL, value: fullUrl })
      window.history.replaceState(null, null, fullUrl);

      // post back to redux to capture the updates (name)
      dispatch({ type: SET_SCREENED_FUNDS, payload: fundsList })
    }
  };
}

// loads basic fund profile ( categories / classifications/ tickers )
export function loadFundProfile() {
  return (dispatch, getState) => {
    const request = {
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/fundchar/profiles?wtRegion=${getState().params.wtRegion}`
    }
    return axios(request)
      .then(response => {
        // dispatch({ type: LOAD_FUND_PROFILE, payload: response.data })
        dispatch({ type: LOAD_FUND_PROFILE, payload: response })
      })
      .catch(error => {
        console.log(error)
      })
  }
}

// loads related WT funds
export function loadRelatedFunds(selectedFunds) {
  return (dispatch, getState) => {
    const funds = selectedFunds.map(fund => fund.value)
    const fundCount = funds.length + getState().params.selectedFunds.length
    if (fundCount > 0 && fundCount < 6 && !getState().params.selectedRelated) {
      const extIds = funds.join(',')
      const request = {
        method: 'GET',
        url: `${process.env.REACT_APP_API_URL}/fundchar/related_funds?wtRegion=${getState().params.wtRegion}&externalIds=${extIds}`
      }
      return axios(request)
        .then(response => {
          const relatedFunds = response.data.filter(fund => !funds.includes(fund.externalID))
          dispatch({ type: LOAD_RELATED_FUNDS, payload: relatedFunds })
        })
        .catch(error => {
          console.log(error)
        })
    } else {
      if (!getState().params.selectedRelated) {
        dispatch({ type: LOAD_RELATED_FUNDS, payload: [] })
      }
      dispatch({ type: SELECTED_RELATED, payload: false })
    }
  }
}

// ****** BLEND FUNCTIONS START ******

export function loadFundDetailsPortfolio(toggleSelection = true) {

  return async (dispatch, getState) => {
    const fundsList = await getState().params.screenedFunds
      .slice(0, 6)
      .map((fund, index) => ({
        id: fund.id || `${fund.ticker}_${index}`,
        externalID: fund.externalID || fund.ticker,
        ticker: fund.ticker,
        rebalance_fq: fund.rebalance_fq || '',
        name: fund.name || '',
        // Preserve selected item type for downstream dataspan payload handling.
        type: fund.type === 'model' ? 'wt_model' : (fund.type || 'ticker'),
      }));
    const fundData = await getState().fundData.data
    const pendingDataspanRequests = await getState().fundData.pendingDataspanRequests
    await cancelRequests(pendingDataspanRequests)

    const isRefreshing = await checkIsRefresh(fundsList, fundData)
    await dispatch(setLoading(true))
    await dispatch(setError(false))
    await dispatch(clearInitialTickers())
    if (toggleSelection) {
      await dispatch(toggleFundSelection())
    }


    await dispatch({ type: CLEAR_SEARCH_RESULTS })

    try {
      if (isRefreshing) {
        await dispatch({ type: FETCH_STRUCTURE_LOADING, payload: true })
      }
      await getFundCompareData(dispatch, fundsList)
      await dispatch(saveToGA('Analyze'))
      await dispatch(saveToGA(getState().params.activePane))
    } catch (error) {
      console.log(error)
    }
  }
}

async function checkIsRefresh(fundsList, fundData) {
  //check fundData first
  if (!fundData || fundData.length === 0) {
    return false
  }
  // Extract 'a' values from A and B
  const valuesFiundList = fundsList.map(obj => obj.externalID);
  const valuesFundData = fundData.map(obj => obj.externalID);

  // Sort the arrays
  valuesFiundList.sort();
  valuesFundData.sort();

  // Check if they are equal
  const areEqual = JSON.stringify(valuesFiundList) === JSON.stringify(valuesFundData);

  return !areEqual
}

async function getFundCompareData(dispatch, fundsList) {
  try {
    dispatch({ type: ERROR, payload: false })
    const responseStructure = await dispatch(fetchBlendedData(fundsList, FUNDCHAR_URL_STRUCTURE))
    const response = { data: { data: responseStructure } }
    // post up the response to redux and stop all the spinners
    dispatch({ type: SET_FUND_DETAILS_STRUCTURE, payload: response.data })
    dispatch({ type: FETCH_STRUCTURE_LOADING, payload: false })
    dispatch({ type: SET_FUND_DETAILS_RUN_ID, payload: { runId: responseStructure?.runId, runEmail: responseStructure?.email } });
    dispatch(setLoading(false))
    dispatch(resetActivePane())
    dispatch(updateQueryParams())
  } catch (error) {
    dispatch(setLoading(false))
    dispatch(updateQueryParams())
    dispatch({ type: ERROR, payload: true })
  }
}

async function fetchBlendedData(fundsList, dataURL) {
  return async (dispatch, getState) => {
    const { advisorEmail, token, unauthUserEmail } = getState().params
    const url = new URL(dataURL);
    url.searchParams.append('advisorEmail', advisorEmail);
    url.searchParams.append('token', token);
    if (!token) {
        url.searchParams.append('unauthEmail', unauthUserEmail);
    }

    // Create a cancellation token source
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    await dispatch({ type: ADD_PENDING_DATASPAN_REQUESTS, payload: source })

    const request = {
      method: 'POST',
      url: url.toString(),
      data: JSON.stringify({ tickers: fundsList }),
      headers: { 'Content-Type': 'application/json' },
    }


    try {
      const response = await axios(request)
      if (Array.isArray(response?.data?.data) && response.data.data.length === 0) {
        const emptyDataError = new Error('Empty dataspan data payload')
        emptyDataError.response = { status: 500, data: response.data }
        throw emptyDataError
      }
      // Remove event listener after successful request

      await dispatch({ type: REMOVE_PENDING_DATASPAN_REQUESTS, payload: source })
      return response.data
    } catch (error) {
      await dispatch({ type: REMOVE_PENDING_DATASPAN_REQUESTS, payload: source })
      if (axios.isCancel(error)) {
        console.log('Request canceled', error.message);
      } else {
        console.log(error)
        throw error
      }
    }
  }
}

async function cancelRequests(pendingDataspanRequests) {
  await pendingDataspanRequests.forEach(token => {
    token.cancel('Operation canceled by the user.');
  });
}


// ****** BLEND FUNCTIONS END ******

export function removeRelatedFund(fund) {
  return dispatch => {
    dispatch({ type: REMOVE_RELATED_FUND, payload: fund })
  }
}

export function loadFundDetailsFromExternalIDs(externalIDs, clearTickers = true) {
  return dispatch => {
    if (clearTickers) {
      dispatch(clearTickers())
    }
    const funds = externalIDs.map(extid => {
      return { externalID: extid }
    })
    dispatch(setFundTickers(funds))
    dispatch(loadFundDetails())
  }
}

export function loadFundDetailsFromTickers(tickers) {
  return dispatch => {
    dispatch(clearTickers())
    const data = { tickers: tickers }
    const request = {
      method: 'POST',
      url: `${process.env.REACT_APP_API_URL}/fundchar/tickernames/`,
      data: data
    }
    return axios(request)
      .then(response => {
        dispatch(setFundTickers(response.data))
        dispatch(loadFundDetails())
      })
      .catch(error => {
        console.log(error)
      })
  }
}

// loads data for fund - all characteristics & breakdowns
export function loadFundDetails() {
  return (dispatch, getState) => {
    dispatch(setError(false))
    dispatch(setLoading(true))
    dispatch(clearInitialTickers())
    dispatch(toggleFundSelection())
    dispatch({ type: SET_SCREENED_FUNDS, payload: [] })
    dispatch({ type: CLEAR_SEARCH_RESULTS })
    let params = `${process.env.REACT_APP_API_URL}/fundchar/data/?`
    params += `advisorEmail=${getState().params.advisorEmail}`
    const list = getState().params.selectedFunds
    const fundsList = []
    list.forEach(element => {
      const d = {}
      d['externalID'] = element.externalID
      d['id'] = element.externalID
      d['ticker'] = element.ticker
      d['rebalance_fq'] = ""
      d['name'] = element.name
      d['type'] = "ticker"

      fundsList.push(d)
    })

    const request = {
      method: 'POST',
      url: params,
      data: JSON.stringify({ tickers: fundsList }),
      headers: { 'Content-Type': 'application/json' },
    }
    return axios(request)
      .then(response => {
        dispatch({ type: LOAD_RELATED_FUNDS, payload: [] })

        // Fund data array is in a data variable (response.data.data)
        dispatch({ type: SET_FUND_DETAILS_STRUCTURE, payload: response })
        dispatch(setLoading(false))
        dispatch(resetActivePane())
        dispatch(saveToGA('Analyze'))
        dispatch(saveToGA(getState().params.activePane))
        dispatch({ type: SET_FUND_DETAILS_RUN_ID, payload: { runId: response?.data?.runId, runEmail: response?.data?.email } });
        dispatch(updateQueryParams())
        dispatch(loadPerformance(getState().params.perfEndDate))
      })
      .catch(error => {
        dispatch(setLoading(false))
        dispatch(setError(true))
        dispatch(toggleFundSelection())
        console.log(error)
      })
  }
}

// loads data for fund - all characteristics & breakdowns
export function loadPerformance(date = null) {
  return (dispatch, getState) => {
    // dispatch({ type: LOAD_PERFORMANCE, payload: null })
    let params = `${process.env.REACT_APP_API_URL}/fundchar/performance?`
    const list = getState().params.selectedFunds
    list.forEach(element => {
      params += `&q=${element.externalID}`
    })
    if (date != null) {
      params += `&date=${date}`
    }
    const request = {
      method: 'GET',
      url: params
    }
    return axios(request)
      .then(response => {
        const restructure = { data: { data: response.data } }
        dispatch({ type: SET_FUND_DETAILS_PERFORMANCE, payload: restructure })
      })
      .catch(error => {
        console.log(error)
      })
  }
}

// loads the fund details excel
export function loadFundDetailsExcel(fullPeriod) {
  return (dispatch, getState) => {
    const fundData = getState().fundData.data
    let fileName = 'Fund-Comparison-Report.xlsx'
    let params = `${process.env.REACT_APP_API_URL}/fundchar/blends_excel/?`
    params += `advisorEmail=${getState().params.advisorEmail}`
    params += `&token=${getState().params.token}`
    params += `&excel=True`
    if (fullPeriod) {
      params += '&hist=true'
      fileName = 'Fund-Comparison-Report-Full-Period.xlsx'
    }
    if (getState().params.perfEndDate != null) {
      params += `&date=${getState().params.perfEndDate}`
    }

    if (fullPeriod) {
      dispatch({ type: SET_FULLEXCEL_STATUS, value: true })
      // dispatch(saveToGA('Export Full'))
    } else {
      dispatch({ type: SET_CURRENTEXCEL_STATUS, value: true })
      // dispatch(saveToGA('Export Current'))
    }
    const request = {
      method: 'POST',
      data: JSON.stringify({ fundData: fundData }),
      responseType: 'blob',
      url: params,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    return axios(request)
      .then(response => {
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName)
        } else {
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = fileName
          a.click()
        }
        if (fullPeriod) {
          dispatch({ type: SET_FULLEXCEL_STATUS, value: false })
        } else {
          dispatch({ type: SET_CURRENTEXCEL_STATUS, value: false })
        }
      })
      .catch(error => {
        console.log(error)
        dispatch({ type: SET_FULLEXCEL_STATUS, value: false })
        dispatch({ type: SET_CURRENTEXCEL_STATUS, value: false })
      })
  }
}

/* sets selected category from fund Profile*/
export function setProfileCategory(param) {
  return dispatch => {
    dispatch({ type: SET_PROFILE_CATEGORY, payload: param })
  }
}

/* sets list of tickers to compare*/
export function setSelectedFundTickers(param) {
  return dispatch => {
    dispatch({ type: SET_SELECTED_FUND_TICKERS, payload: param })
  }
}

export function setFundTickers(funds) {
  return dispatch => {
    dispatch({ type: SET_TA_FUND_TICKERS, payload: funds })
    dispatch(updateQueryParams())
  }
}

/* sets list of type ahead ids to compare*/
export function setTAFundTickers(param) {
  const funds = param.map(fund => {
    return {
      externalID: fund.value
    }
  })
  return dispatch => {
    dispatch({ type: SET_TA_FUND_TICKERS, payload: funds })
    dispatch(updateQueryParams())
  }
}

/* sets which page to show */
export function setActivePane(param) {
  return (dispatch, getState) => {
    dispatch({ type: SET_ACTIVE_PANE, payload: param })
    dispatch(updateQueryParams())
  }
}

export function resetActivePane() {
  return (dispatch, getState) => {
    const fundsWithTilts = getState().fundData.data.filter(x => x.multifactorTilts !== null)
    const fundsWithAggs = getState().fundData.data.filter(x => x.aggregateFundamentals !== null)
    if (getState().params.activePane === paneOpts.factors && fundsWithTilts.length === 0) {
      dispatch(setActivePane(paneOpts.perf))
    }
    if (getState().params.activePane === paneOpts.chars && fundsWithAggs.length === 0) {
      dispatch(setActivePane(paneOpts.perf))
    }
  }
}

/* used to restore option dropdown and funds so user can request a different list of data*/
export function resetPage(param) {
  return dispatch => {
    dispatch({ type: RESET_PAGE, payload: param })
  }
}

/* sets list of chars to display series chart data */
export function setSelectedChars(param) {
  return dispatch => {
    dispatch({ type: SET_SELECTED_CHARS, payload: param })
  }
}

/* sets list of ESGRiskRating to display overall risk */
export function setSelectedRisk(param) {
  return dispatch => {
    dispatch({ type: SET_SELECTED_RISK, payload: param })
  }
}
/* sets sector to display series chart data */
export function setSelectedSector(param) {
  return dispatch => {
    dispatch({ type: SET_SELECTED_SECTOR, payload: param })
  }
}

/* sets country to display series chart data */
export function setSelectedCountry(param) {
  return dispatch => {
    dispatch({ type: SET_SELECTED_COUNTRY, payload: param })
  }
}

export function resetScrollCountry() {
  return dispatch => {
    dispatch({ type: RESET_SCROLL_COUNTRY })
  }
}

export function removeTicker(param) {
  return (dispatch, getState) => {
    dispatch({ type: REMOVE_TICKER, payload: param })
    dispatch(resetActivePane())
    dispatch(updateQueryParams())
  }
}

export function clearTickers() {
  return async (dispatch, getState) => {
    dispatch({ type: CLEAR_TICKERS })
    dispatch(updateQueryParams())
    const pendingDataspanRequests = await getState().fundData.pendingDataspanRequests
    await cancelRequests(pendingDataspanRequests)

  }
}

export function clearInitialTickers() {
  return dispatch => {
    dispatch({ type: CLEAR_INITIAL_TICKERS })
  }
}

export function setLoading(param) {
  return dispatch => {
    dispatch({ type: LOADING, payload: param })
  }
}

export function setPerfLoading(param) {
  return dispatch => {
    dispatch({ type: PERF_LOADING, payload: param })
  }
}

export function setError(param) {
  return dispatch => {
    dispatch({ type: ERROR, payload: param })
  }
}


export function setSelectedRelated(value) {
  return dispatch => {
    dispatch({ type: SELECTED_RELATED, payload: value })
  }
}

export function setPerfStartDate(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_PERF_START_DATE, payload: value })
    dispatch(updateQueryParams())
  }
}

export function setPerfEndDate(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_PERF_END_DATE, payload: value })
    dispatch(updateQueryParams())
  }
}

export function saveToGA(eventAction) {
  return (dispatch, getState) => {
    const e = {
      eventName: 'fund comparison',
      eventAction: eventAction,
      eventLabel: getState()
        .fundData.data.map(fund => `${fund.ticker}`)
        .join('|'),
      type: 'CustomTagEvent'
    }

    if (window.digitalData) {
      if (e.Label !== '') {
        window.digitalData.newEvent(e)
        console.log('digitalData: ', e)
      } else {
        console.warn('no digitial data')
      }
    }
  }
}

export function setMetricQuality(value) {
  return dispatch => {
    dispatch({ type: SET_GROWTH_METRIC_QUALITY, payload: value })
  }
}

export function setAllGrowthChars(value) {
  return dispatch => {
    dispatch({ type: SET_ALL_GROWTH_CHARS, payload: value })
  }
}

/* sets country to display series chart data */
export function setSeeAdditionalPI(param) {
  return dispatch => {
    dispatch({ type: SET_SELECT_ADDITIONALPI, payload: param })
  }
}

export function setActiveSoeDataType(value) {
  return dispatch => {
    // console.log('ACTIONS', value)
    dispatch({ type: SET_ACTIVE_SOE_DATA_TYPE, payload: value })
  }
}
/* sets which  soe level page to show */
export function setActiveSoePane(param) {
  return (dispatch, getState) => {
    dispatch({ type: SET_ACTIVE_SOE_PANE, payload: param })
  }
}

export function setDrawDownPeriod(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_DRAW_DOWN_PERIOD, payload: value })
    //dispatch(updateQueryParams());
  }
}

/* toggles the fund selection */
export function toggleFundSelection() {
  return (dispatch, getState) => {
    dispatch({ type: TOGGLE_SHOW_FUND_SELECTION })
  }
}

export function setLoadingSearchResults(param) {
  return dispatch => {
    dispatch({ type: LOADING_SEARCH_RESULTS, payload: param })
  }
}

// Search for funds using fund screener
export function searchForFunds(searchString) {
  return (dispatch, getState) => {
    dispatch(setError(false))
    dispatch(setLoadingSearchResults(true))

    let url = `${process.env.REACT_APP_API_URL}/fundchar/search/`
    const request = {
      method: 'GET',
      url: url,
      params: {
        q: searchString
      }
    }
    return axios(request)
      .then(response => {
        // Enrich fund data
        const searchFunds = response.data.map(fund => {
          fund.inceptionDt = new Date(fund.inceptionDate)
          return fund
        })
        dispatch({ type: LOAD_SEARCH_RESULTS, payload: searchFunds })
        dispatch(setError(false))
        dispatch(setLoadingSearchResults(false))
      })
      .catch(error => {
        dispatch(setLoadingSearchResults(false))
        dispatch(setError(true))
        console.log(error)
      })
  }
}

export function addScreenedFund(fund) {
  return dispatch => {
    dispatch({ type: ADD_SCREENED_FUND, payload: fund })
  }
}

export function hardSetScreendFunds(funds) {
  return dispatch => {
    dispatch({ type: SET_SCREENED_FUNDS, payload: funds })
  }
}

export function loadPersonalStrategies() {
  return (dispatch, getState) => {
    let params = getState().params

    if (params.token !== 'undefined') {
      const request = {
        method: 'GET',
        url: `${process.env.REACT_APP_API_URL}/personalstrategies/`,
        params: {
          clientEmail: params.advisorEmail
        },
        headers: {
          Authorization: params.token && `Token ${params.token}`
        }
      }
      return axios(request)
        .then(response => {
          if (response.status === 200) {
            const sortedData = [...response.data].sort((a, b) => {
              // Sort a and b
              return new Date(a.updateDate) >= new Date(b.updateDate) ? -1 : 1
            })
            dispatch({ type: LOAD_PERSONAL_STRATEGIES, payload: sortedData })
          }
        })

        .catch(error => {
          if (error.response.status === 404) {
            dispatch({ type: LOAD_PERSONAL_STRATEGIES, payload: [] })
          }
        })
    } // If token isn't valid then don't load anything
    else {
      dispatch({ type: LOAD_PERSONAL_STRATEGIES, payload: [] })
    }
  }
}

export function showPersonalStrategy(idToShow) {
  return (dispatch, getState) => {
    dispatch({ type: SHOW_A_STRATEGY, payload: idToShow })
  }
}

// Show all strategies in the StrategyList
export function showAllStrategies() {
  return (dispatch, getState) => {
    dispatch({ type: SHOW_ALL_STRATEGIES })
  }
}

// Show the Strategy editor. May be called from the StrategyList
// or an individual StrategyRow
export function showStrategyEditor(personalStrategy) {
  console.log('showStrategyEditor', personalStrategy)
  return (dispatch, getState) => {
    dispatch({ type: SHOW_STRATEGY_EDITOR, payload: personalStrategy })
  }
}

// Close the StrategyEditor
export function closeStrategyEditor() {
  return (dispatch, getState) => {
    dispatch({ type: CLOSE_STRATEGY_EDITOR })
  }
}

// Update the Personal Strategy's details (e.g., name)
export function saveNewStrategy(fieldsToUpdate) {
  return (dispatch, getState) => {
    // Let the StrategyList know that a new strategy is being saved
    dispatch({ type: SAVING_NEW_STRATEGY_IN_PROGRESS, payload: fieldsToUpdate })

    let params = getState().params

    let body = {
      clientEmail: params.clientEmail,
      wtRegion: params.wtRegion,
      name: fieldsToUpdate.name,
      holdings: fieldsToUpdate.holdings,
      totalValue: fieldsToUpdate.totalValue
    }

    // Add a benchmark if one has been added
    if (fieldsToUpdate.benchmarkExternalID) {
      body.benchmarks = [
        {
          externalID: fieldsToUpdate.benchmarkExternalID
        }
      ]
    }

    if (params.token !== 'undefined') {
      const request = {
        method: 'POST',
        url: `${process.env.REACT_APP_API_URL}/personalstrategies/`,
        data: body,
        headers: {
          'Content-Type': 'application/json',
          Authorization: params.token && `Token ${params.token}`
        }
      }
      return axios(request)
        .then(response => {
          dispatch({ type: SAVE_NEW_STRATEGY, payload: response.data })
          dispatch({ type: SAVING_STRATEGY_COMPLETE })
          console.log('RESPONSE- sav personal strat', response)
          console.log('REQUEST- sav personal strat', request)
          // Update the Hash URL to force dpd to reload
          window.location = '#myportfolios&reloadhistory=true'

          // Optimize the strategy now it's been created
          optimizePersonalStrategy(dispatch, params, response.data.id)
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}

// Update the Personal Strategy's details (e.g., name)
export function updateStategyDetails(fieldsToUpdate) {
  return (dispatch, getState) => {
    // Let the StrategyList know that one of the strategies is being saved
    dispatch({ type: SAVING_STRATEGY_IN_PROGRESS, payload: fieldsToUpdate.id })

    let params = getState().params

    let body = {
      clientEmail: params.clientEmail,
      name: fieldsToUpdate.name,
      totalValue: fieldsToUpdate.totalValue
    }

    // Check if holdings were updated
    if (fieldsToUpdate.holdings) {
      body.holdings = fieldsToUpdate.holdings
    }

    // Add a benchmark if one has been added, otherwise force it to be blanked out with empty array
    if (fieldsToUpdate.benchmarkExternalID) {
      body.benchmarks = [
        {
          externalID: fieldsToUpdate.benchmarkExternalID
        }
      ]
    } else {
      body.benchmarks = []
    }

    if (params.token !== 'undefined' && fieldsToUpdate.id) {
      const request = {
        method: 'PUT',
        url: `${process.env.REACT_APP_API_URL}/personalstrategies/${fieldsToUpdate.id}/`,
        data: body,
        headers: {
          'Content-Type': 'application/json',
          Authorization: params.token && `Token ${params.token}`
        }
      }
      return axios(request)
        .then(response => {
          dispatch({ type: UPDATE_STRATEGY, payload: response.data })
          dispatch({ type: SAVING_STRATEGY_COMPLETE })
          console.log('RESPONSE- opt ', response)
          console.log('REQUEST - opt', request)
          // Update the Hash URL to force dpd to reload
          window.location = '#myportfolios&reloadhistory=true'

          // Check if holdings were updated
          if (fieldsToUpdate.holdings) {
            // Optimize the strategy now it's been created
            optimizePersonalStrategy(dispatch, params, fieldsToUpdate.id)
          }
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}

function optimizePersonalStrategy(dispatch, params, idToOptimize) {
  const body = {
    clientEmail: params.clientEmail
  }

  if (params.token !== 'undefined' && idToOptimize) {
    const request = {
      method: 'POST',
      url: `${process.env.REACT_APP_API_URL}/personalstrategies/${idToOptimize}/optimize/`,
      data: body,
      headers: {
        'Content-Type': 'application/json',
        Authorization: params.token && `Token ${params.token}`
      }
    }
    return axios(request)
      .then(response => {
        dispatch({ type: UPDATE_STRATEGY, payload: response.data })
        console.log('RESPONSE-updatek', response)
        console.log('REQUEST -update', request)
      })
      .catch(error => {
        console.error(error)
      })
  }
}

export function deletePersonalStrategy(idToDelete) {
  return (dispatch, getState) => {
    // Let the StrategyList know that one of the strategies is being deleted
    dispatch({ type: SAVING_STRATEGY_IN_PROGRESS, payload: idToDelete })

    let params = getState().params

    const body = {
      clientEmail: params.clientEmail,
      isDeleted: true
    }

    if (params.token !== 'undefined' && idToDelete) {
      const request = {
        method: 'PUT',
        url: `${process.env.REACT_APP_API_URL}/personalstrategies/${idToDelete}/`,
        data: body,
        headers: {
          'Content-Type': 'application/json',
          Authorization: params.token && `Token ${params.token}`
        }
      }
      return axios(request)
        .then(response => {
          dispatch({ type: DELETE_A_STRATEGY, payload: idToDelete })
          dispatch({ type: SHOW_ALL_STRATEGIES })
          dispatch({ type: SAVING_STRATEGY_COMPLETE })
          console.log('RESPONSE-del personal strat', response)
          console.log('REQUEST del personal strat', request)
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}

// Create a new strategy out of a portfolio from DPD
export function savePortfolioAsNewStrategy(portfolioId, portfolioName) {
  return (dispatch, getState) => {
    let params = getState().params

    let body = {
      clientEmail: params.clientEmail,
      portfolioId: portfolioId,
      portfolioName: portfolioName
    }

    if (params.token !== 'undefined' && portfolioId) {
      const request = {
        method: 'POST',
        url: `${process.env.REACT_APP_API_URL}/personalstrategies/create_from_portfolio/`,
        data: body,
        headers: {
          'Content-Type': 'application/json',
          Authorization: params.token && `Token ${params.token}`
        }
      }
      return axios(request)
        .then(response => {
          dispatch({ type: SAVE_NEW_STRATEGY, payload: response.data })

          // Update the Hash URL to let DPD know saving has finished
          window.location = '#dpd&savedToMyPortfolios=' + portfolioId + '&newMyPortfolio=' + response.data.id
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}

/// Get all the benchmarks from the database
export function getBenchmarks() {
  return (dispatch, getState) => {
    let params = getState().params

    if (params.token !== undefined) {
      const request = {
        method: 'GET',
        url: `${process.env.REACT_APP_DPD_URL}/api/benchmarks/all/`,
        params: {
          clientEmail: params.clientEmail,
          entityCCY: params.entityCCY,
          wtRegion: params.wtRegion
        },
        headers: {
          Authorization: params.token && `Token ${params.token}`
        }
      }
      return axios(request)
        .then(response => {
          if (response.status === 200) {
            dispatch({ type: LOAD_BENCHMARKS, payload: response.data })
          }
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}

export function removeScreendFund(fund) {
  return dispatch => {
    dispatch({ type: REMOVE_SCREENED_FUND, payload: fund })
  }
}

export function updateSearchTicker(ticker) {
  return dispatch => {
    dispatch({ type: UPDATE_SEARCH_TICKER, payload: ticker })
  }
}

export function removeSearchTicker(ticker) {
  return dispatch => {
    dispatch({ type: REMOVE_SEARCH_TICKER, payload: ticker })
  }
}

export function appendSearchTicker(ticker) {
  return dispatch => {
    dispatch({ type: APPEND_SEARCH_TICKER, payload: ticker })
  }
}

export function updateFundCount(fund) {
  return dispatch => {
    dispatch({ type: UPDATE_FUND_COUNT, payload: fund })
  }
}
